import React from "react";
import { CheckboxProps } from "@mui/material";

import * as S from "./styles";
import RenderTooltipMessage from "../renderTooltipMessage/renderTooltipMessage";

interface IKogCheckboxProps extends CheckboxProps {
	tooltipMessage?: string;
}

const KogCheckbox = React.forwardRef(({ tooltipMessage, ...props }: IKogCheckboxProps, ref: any) => {
	return (
		<RenderTooltipMessage tooltipMessage={tooltipMessage}>
			<S.CustomCheckbox {...props} ref={ref} />
		</RenderTooltipMessage>
	);
});

export default KogCheckbox;
